export default "assets/terroirs-map-overlay-9c8d34a7.svg";